"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[649],{

/***/ 68219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; },
/* harmony export */   "H4": function() { return /* binding */ H4; },
/* harmony export */   "HU": function() { return /* binding */ FooterText; },
/* harmony export */   "O": function() { return /* binding */ CardParagraph; },
/* harmony export */   "nv": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* unused harmony export FooterLink */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71383);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46133);


var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;


var H1 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1 */ .ZP.h1(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: 1.5rem;\n  text-align: ", ";\n  font-size: ", ";\n  @media screen and (max-width: ", ") {\n    font-size: ", ";\n  }\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.typography.headingFontFamily;
}, function (_ref2) {
  var $textAlign = _ref2.$textAlign;
  return $textAlign ? $textAlign : 'initial';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.desktopFontSize.title;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.mobileFontSize.title;
}, function (_ref6) {
  var theme = _ref6.theme,
      $brand = _ref6.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject2 || (_templateObject2 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: ", ";\n  font-size: ", ";\n  position: ", ";\n  left: ", ";\n  color: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.typography.headingFontFamily;
}, function (_ref8) {
  var $marginBottom = _ref8.$marginBottom;
  return $marginBottom || '1.5rem';
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typography.fontSizes[2];
}, function (_ref10) {
  var $sticky = _ref10.$sticky;
  return $sticky ? 'sticky' : 'initial';
}, function (_ref11) {
  var $sticky = _ref11.$sticky;
  return $sticky ? 0 : 'initial';
}, function (_ref12) {
  var theme = _ref12.theme,
      $brand = _ref12.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject3 || (_templateObject3 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.typography.headingFontFamily;
}, function (_ref14) {
  var $color = _ref14.$color;
  return $color ? $color : 'inherit';
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.typography.fontSizes[4];
});
var H4 = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h4 */ .ZP.h4(_templateObject4 || (_templateObject4 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: ", ";\n  margin: initial;\n  margin-bottom: initial;\n  color: ", ";\n  font-size: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.typography.headingFontFamily;
}, function (_ref17) {
  var $padding = _ref17.$padding;
  return $padding ? $padding : 'initial';
}, function (_ref18) {
  var theme = _ref18.theme,
      $brand = _ref18.$brand;
  return $brand ? theme.colors.primary : theme.colors.text;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.typography.fontSizes[5];
}, function (_ref20) {
  var $ellipsis = _ref20.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref21) {
  var $ellipsis = _ref21.$ellipsis;
  return $ellipsis && 2;
}, function (_ref22) {
  var $ellipsis = _ref22.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref23) {
  var $ellipsis = _ref23.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref24) {
  var $ellipsis = _ref24.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref25) {
  var $ellipsis = _ref25.$ellipsis;
  return $ellipsis && '3.4rem';
});
var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject5 || (_templateObject5 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  text-align: ", ";\n  padding: ", ";\n  margin: initial;\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: calc(\n    ", " * 2\n  );\n  color: ", ";\n\n  display: ", ";\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: ", ";\n  overflow: ", ";\n  text-overflow: ", ";\n  min-height: ", ";\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref27) {
  var $textAlign = _ref27.$textAlign;
  return $textAlign ? $textAlign : 'left';
}, function (_ref28) {
  var $padding = _ref28.$padding;
  return $padding ? $padding : '2rem 0';
}, function (_ref29) {
  var $fontWeight = _ref29.$fontWeight;
  return $fontWeight ? $fontWeight : 'initial';
}, function (_ref30) {
  var theme = _ref30.theme;
  return theme.typography.fontSizes[5];
}, function (_ref31) {
  var theme = _ref31.theme,
      $lineHeight = _ref31.$lineHeight;
  return $lineHeight ? $lineHeight : theme.typography.fontSizes[5];
}, function (_ref32) {
  var theme = _ref32.theme,
      $brand = _ref32.$brand,
      $color = _ref32.$color;
  return $brand ? theme.colors.primary : theme.colors[$color || 'text'];
}, function (_ref33) {
  var $ellipsis = _ref33.$ellipsis;
  return $ellipsis && '-webkit-box';
}, function (_ref34) {
  var $ellipsis = _ref34.$ellipsis;
  return $ellipsis && 4;
}, function (_ref35) {
  var $ellipsis = _ref35.$ellipsis;
  return $ellipsis && 'vertical';
}, function (_ref36) {
  var $ellipsis = _ref36.$ellipsis;
  return $ellipsis && 'hidden';
}, function (_ref37) {
  var $ellipsis = _ref37.$ellipsis;
  return $ellipsis && 'ellipsis';
}, function (_ref38) {
  var $ellipsis = _ref38.$ellipsis;
  return $ellipsis && '9.7rem';
});
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6 || (_templateObject6 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: ", ";\n  max-width: 100vw;\n  overflow-wrap: break-word;\n  @media screen and (min-width: ", ") {\n    font-size: ", ";\n  }\n"])), function (_ref39) {
  var $textAlign = _ref39.$textAlign;
  return $textAlign ? $textAlign : 'center';
}, function (_ref40) {
  var theme = _ref40.theme;
  return theme.breakpoints.sm.maxWidth;
}, function (_ref41) {
  var theme = _ref41.theme;
  return theme.typography.fontSizes[3];
});
var CardParagraph = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].p */ .ZP.p(_templateObject7 || (_templateObject7 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  padding: initial;\n  margin: initial;\n  font-size: ", ";\n  line-height: calc(", " * 1.25);\n  color: ", ";\n"])), function (_ref42) {
  var theme = _ref42.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref43) {
  var theme = _ref43.theme;
  return theme.typography.fontSizes[5];
}, function (_ref44) {
  var theme = _ref44.theme;
  return theme.typography.fontSizes[5];
}, function (_ref45) {
  var $color = _ref45.$color,
      theme = _ref45.theme;
  return $color ? $color : theme.colors.text;
});
var FooterLink = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].a */ .ZP.a(_templateObject8 || (_templateObject8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  font-family: ", ";\n  color: ", ";\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref46) {
  var theme = _ref46.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref47) {
  var theme = _ref47.theme,
      $brand = _ref47.$brand;
  return $brand ? theme.colors.linkColours.alt : theme.colors.text;
}, function (_ref48) {
  var theme = _ref48.theme,
      $brand = _ref48.$brand;
  return $brand ? theme.colors.linkColours.altHover : theme.colors.text;
});
var FooterText = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject9 || (_templateObject9 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(["\n  text-align: center;\n  max-width: 800px;\n  line-height: 1.2;\n  a {\n    font-family: ", ";\n    color: ", ";\n  }\n"])), function (_ref49) {
  var theme = _ref49.theme;
  return theme.typography.bodyFontFamily;
}, function (_ref50) {
  var theme = _ref50.theme;
  return theme.colors.primary;
});

/***/ }),

/***/ 39649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16835);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(59499);
/* harmony import */ var atomic_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19010);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89755);
/* harmony import */ var next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_legacy_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68219);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(18813);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46133);
/* harmony import */ var utils_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92442);
/* harmony import */ var components_content_calculator_calculationContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93138);
/* harmony import */ var _utils_convertBtcSats__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72583);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);




var _templateObject;











/**
 * Invest {amountToInvest} per {stackingFrequency}
 * To reach your {goalAmount}{goalAmountUnit} by {goalDate}
 *
 * Complete the calculator inputs to find your investment targets.
 */




var SummaryCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(atomic_layout__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu)(function (_ref) {
  var _ref2;

  var theme = _ref.theme,
      marginBottomOnXl = _ref.marginBottomOnXl,
      marginBottomSm = _ref.marginBottomSm,
      marginBottomLg = _ref.marginBottomLg,
      marginTopLg = _ref.marginTopLg;
  return _ref2 = {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'space-between',
    backdropFilter: "blur(".concat(theme.glassEffect.blur, ")"),
    '-webkit-backdrop-filter': "blur(".concat(theme.glassEffect.blur, ")"),
    borderRadius: theme.glassEffect.borderRadius,
    background: theme.colors.glassBackground,
    overflow: 'hidden',
    minHeight: '115px',
    maxWidth: '600px',
    boxShadow: theme.colors.shadow
  }, (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, "@media screen and (max-width: ".concat(theme.breakpoints.sm.maxWidth, ")"), {
    justifyContent: 'left'
  }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, "@media screen and (min-width: ".concat(theme.breakpoints.lg.maxWidth, ")"), {
    marginBottom: "".concat(marginBottomOnXl, " !important")
  }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, "@media screen and (min-width: ".concat(theme.breakpoints.md.minWidth, ")"), {
    marginBottom: "".concat(marginBottomSm, "rem")
  }), (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_ref2, "@media screen and (min-width: ".concat(theme.breakpoints.lg.minWidth, ")"), {
    marginBottom: "".concat(marginBottomLg, "rem"),
    marginTop: "".concat(marginTopLg, "rem")
  }), _ref2;
});
var BitcoinImageBox = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(function (_ref3) {
  var theme = _ref3.theme;
  return (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
    height: '100%',
    background: theme.colors.secondaryGradient,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: '0 1 100px',
    padding: '0 0.2rem'
  }, "@media screen and (min-width: ".concat(theme.breakpoints.sm.minWidth, ")"), {
    minWidth: '120px',
    padding: 'unset'
  });
});
var TextWrapperBox = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(["\n  padding: 0.5rem 1rem;\n  text-align: right;\n  flex: 1;\n"])));
var Text = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].p */ .ZP.p(function (_ref5) {
  var theme = _ref5.theme,
      $big = _ref5.$big,
      $bold = _ref5.$bold,
      $nowrap = _ref5.$nowrap,
      $color = _ref5.$color;
  return {
    color: $color ? theme.colors[$color] : theme.colors.text,
    fontSize: $big ? '24px' : '14px',
    fontWeight: $big || $bold ? 'bold' : 'normal',
    margin: $big ? '0.5rem 0' : 0,
    lineHeight: 1.2,
    padding: 0,
    whiteSpace: $nowrap ? 'no-wrap' : 'pre-line'
  };
});
var Span = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].span */ .ZP.span(function (_ref6) {
  var theme = _ref6.theme,
      $color = _ref6.$color,
      $nowrap = _ref6.$nowrap;
  return {
    color: $color ? theme.colors[$color] : theme.colors.text,
    fontSize: 'inherit',
    whiteSpace: $nowrap ? 'no-wrap' : 'preline'
  };
});

var templateString = function templateString(template, formattedValues) {
  return Object.entries(formattedValues).reduce(function (str, _ref7) {
    var _ref8 = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return str.replace(new RegExp("{".concat(key, "}"), 'g'), value || '');
  }, template);
};

var SummaryText = function SummaryText(_ref9) {
  var byGoalSummaryText = _ref9.byGoalSummaryText,
      byInvestmentAmountSummaryText = _ref9.byInvestmentAmountSummaryText;

  var _useCalculation = (0,components_content_calculator_calculationContext__WEBPACK_IMPORTED_MODULE_5__/* .useCalculation */ .C)(),
      useStackingAmount = _useCalculation.useStackingAmount,
      stackingAmount = _useCalculation.stackingAmount,
      singleStatData = _useCalculation.singleStatData,
      amountToInvest = _useCalculation.amountToInvest,
      stackingFrequency = _useCalculation.stackingFrequency,
      goalDate = _useCalculation.goalDate,
      currency = _useCalculation.currency,
      isSatoshis = _useCalculation.isSatoshis;

  var marginBottomSm = singleStatData !== null && singleStatData !== void 0 && singleStatData.purchasingPower ? 0 : 0;
  var marginBottomLg = singleStatData !== null && singleStatData !== void 0 && singleStatData.purchasingPower ? 0.8 : 1.2;

  var _ref10 = singleStatData || {},
      totalCrypto = _ref10.totalCrypto;

  var totalCryptoToUse = isSatoshis ? totalCrypto === null || totalCrypto === void 0 ? void 0 : totalCrypto.mul(_utils_convertBtcSats__WEBPACK_IMPORTED_MODULE_6__/* .SATOSHI_FACTOR */ .Zx) : totalCrypto;
  var totalAmountToInvestInUnit = amountToInvest;
  var summaryTextProps = useStackingAmount ? byInvestmentAmountSummaryText : byGoalSummaryText;

  var _ref11 = summaryTextProps || {},
      upper = _ref11.upper,
      stat = _ref11.stat,
      unit = _ref11.unit,
      lower = _ref11.lower,
      fallbackText = _ref11.fallbackText;

  var templateValues = react__WEBPACK_IMPORTED_MODULE_3__.useMemo(function () {
    var _totalCryptoToUse$toN;

    return {
      amountToInvest: amountToInvest && currency && (0,utils_currency__WEBPACK_IMPORTED_MODULE_4__/* .toCurrencyString */ .mr)(useStackingAmount ? stackingAmount : totalAmountToInvestInUnit, currency),
      stackingFrequency: stackingFrequency === null || stackingFrequency === void 0 ? void 0 : stackingFrequency.replace(/i?ly$/i, '').replace('DA', 'DAY').toLowerCase(),
      totalAmount: totalCryptoToUse === null || totalCryptoToUse === void 0 ? void 0 : (_totalCryptoToUse$toN = totalCryptoToUse.toNumber()) === null || _totalCryptoToUse$toN === void 0 ? void 0 : _totalCryptoToUse$toN.toLocaleString(undefined, {
        maximumFractionDigits: isSatoshis ? 0 : totalCrypto >= 1 ? 3 : 8
      }),
      totalAmountUnit: isSatoshis ? 'sats' : 'BTC',
      totalAmountUnitGoal: isSatoshis ? 'SatsGoal' : 'BTC Goal',
      goalDate: goalDate && (0,date_fns_format__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(goalDate, 'do MMMM yyyy')
    };
  }, [amountToInvest, currency, useStackingAmount, stackingAmount, stackingFrequency, totalCrypto, isSatoshis, goalDate]);
  var color = 'primary';
  var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__/* .useTheme */ .Fg)();
  var isDark = theme.isDark;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(SummaryCard, {
    maxHeight: '100%',
    marginBottomOnXl: '0px',
    marginBottomSm: marginBottomSm,
    marginBottomLg: marginBottomLg,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(BitcoinImageBox, {
      $color: color,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_legacy_image__WEBPACK_IMPORTED_MODULE_1___default()), {
        src: __webpack_require__(2750),
        style: {
          transform: 'rotate(1deg)',
          filter: !isDark && 'brightness(0) invert(1)'
        },
        alt: "Bitcoin Logo"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(TextWrapperBox, {
      children: [!!amountToInvest && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Text, {
          $color: color,
          $bold: true,
          $nowrap: true,
          children: templateString(upper, templateValues)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(Text, {
          $big: true,
          $nowrap: true,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Span, {
            $color: color,
            children: templateString(stat, templateValues)
          }), ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Span, {
            $nowrap: true,
            children: templateString(unit, templateValues)
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Text, {
          children: templateString(lower, templateValues)
        })]
      }), !amountToInvest && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__/* .Summary */ .ER, {
        $padding: "initial",
        $textAlign: "right",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(components_atoms_Text__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
          $padding: "initial",
          $textAlign: "right",
          children: fallbackText
        })
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (SummaryText);

/***/ }),

/***/ 2750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/bitcoinLogo2.625bab8b.svg","height":48,"width":35});

/***/ })

}]);